<div class="zoneiq-top-panel" style="justify-content: space-between;">
    <h3>Gridics Uses Tags</h3>
    <div style="padding: 10px 0;">
        <button (click)="createUseTag()" class="button action" style="height: 45px;">Create Tag</button>
    </div>
</div>
<div class="pt1 pb1 zoneiq-central-panel">
    <div class="pr1 pl1">
        <div class="general-items-table gridics-uses-tags-table">
            <div class="column-title flex between align-center">
                <span *ngFor="let field of tableFields">{{field}}</span>
            </div>
            <div class="table-body">
                <div *ngFor="let useTag of useTags$ | async" class="table-row flex between align-center admin-table-row">
                    <div class="row-sector record-values-container admin-table-row-label">
                        <span>{{ useTag.GridicsUse }}</span>
                    </div>
                    <div class="flex actions-container">
                        <div class="action-buttons flex between align-center">
                            <div class="icon-button-container" (click)="editUseTag(useTag)">
                                <i class="material-icons action-icon">edit</i>
                                <span class="flex between align-center popup">Edit</span>
                            </div>
                            <div class="icon-button-container" (click)="deleteUseTag(useTag)">
                                <i class="material-icons action-icon">close</i>
                                <span class="flex between align-center popup">Delete</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
